
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// reactstrap components
import { Form, FormGroup, Label, Button, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useTranslate } from 'react-translate';
import UploadAsyncContacts from './UploadAsyncContacts';
import { actionSubmitStudyFile } from 'store/actions/laboratoryActions';
import { useHistory } from 'react-router';
import UploadInvitePatientForm from './UploadInvitePatientForm';
import { actionSetNewPatientData } from 'store/actions/analysisActions';
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';

const UploadForm = ({ }) => {
  const t = useTranslate('analysis');
  const tUpload = useTranslate('study-upload');
  const tTypes = useTranslate("study-type");
  const history = useHistory();
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const practiceId = useSelector((state) => state.userAuthorizationReducer._id);
  const patientData = useSelector(state => state.analysisReducer.patientData);
  const studyTypes = useSelector(state => state.analysisReducer.studyTypes);
  const { studyUploadInProcess } = useSelector(state => state.laboratoryReducer);
  const isPatientDataNull = !Object.keys(patientData).length;
  const roles = useSelector(state => state.userAuthorizationReducer);
  const user = useSelector(state => state.userReducer);
  const [analysisType, setAnalysisType] = useState("empty");
  const { mobile } = useSelector(
      (state) => state.commonReducer
    );
  const isSecretary = roles.key === "secretary";

  const [inviteOpen, setInviteOpen] = useState(false);

  useEffect(() => {
    if (!isPatientDataNull) {
      setInviteOpen(false);
    }
  }, [patientData]);

  const modalToggle = () => {
    setInviteOpen(!inviteOpen);
  }

  useEffect(() => {
    return () => {
      dispatch(actionSetNewPatientData({}));
    }
  }, []);

  const defaultValues = {
    patient_email: "",
    doctor_email: "",
    device_id: ""
  };

  const { register, handleSubmit, control, errors } = useForm({
    defaultValues,
  });

  /**
   *  Validate file size
   * @param {object} file selected
   * @param {number} size Mb
   */
  const validateFileSize = (file, size) => {
    if (file && file.size) {
      return file.size <= parseInt(size) * 1024 * 1024;
    }
    return false;
  };

  //Manual file verification
  const handleChange = (e) => {

    let file = e.target.files[0];

    const fileName = e.target.value.split(".");
    const fileExt = fileName[fileName.length - 1];

    //Check for max file size
    if (!validateFileSize(file, 6)) {
      e.target.value = '';
      return toast.error(
          `${tUpload('alert-error-size-file')} 6 Mb `
      );
    }

    //Check for file extension
    if (fileExt.toLowerCase() !== "pdf") {
      e.target.value = '';
      return toast.error(
          `${tUpload('alert-error-file-unsupported')}`
      );
    }

    if (file && file.name) {

      //Encode filename and create new file Blob
      const encodedName = encodeURIComponent(file.name);
      const blob = file.slice(0, file.size, file.type);
      const newFile = new File([blob], encodedName, {type: file.type});

      setFile(newFile);
    }
  };


  const onSubmit = (data) => {

    if (analysisType === "empty") {
      toast.error(t("error-type-not-selected"));
      return;
    }

    if (isSecretary && !data.doctor) {
      toast.error(t("error-doctor-not-selected"));
      return;
    }

    if (!data.patient && isPatientDataNull) {
      toast.error(t("error-patient-not-selected"));
      return;
    }

    if (!file) {
      toast.error(tUpload("error-file-not-selected"));
      return;
    }
    

    dispatch(actionSubmitStudyFile({
      doctor_email: !isSecretary ? user.email : data.doctor.value,
      patient_email: !isPatientDataNull ? patientData.email : data.patient.value,
      practice: practiceId,
      study: file,
      type: analysisType
    }));
  };

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>

        <FormGroup>
          <Label for="type">{t("study-type")}</Label>
            <Input 
              className={analysisType === "empty" ? `has-danger` : ""}
              type="select" 
              name="type" 
              id="type"
              ref={register}
              onChange={(e) => {
                setAnalysisType(e.target.value);
              }}
            >
              <option value="empty">-</option>
              {studyTypes.length && studyTypes.map(tp => {
                return <option value={tp}>{tTypes(tp.replace(" ", '-'))}</option>;
              })}
            </Input>
        </FormGroup>

        <Label for="study-attachment">{tUpload("study")}</Label>
        <Input
            className={`form-control`}
            type="file"
            name={`study-attachment`}
            onChange={handleChange}
            ref={register}
            accept={[".pdf"]}
            disabled={studyUploadInProcess}
        />
        <Label>{`${tUpload('max-file-size')}: 6 Megabytes (MB)`}</Label>

        <br/>
        <br/>

        <FormGroup>
            <Label for="to">{t("doctor")}</Label>
            {isSecretary ? 
                <UploadAsyncContacts
                    name="doctor"
                    disabled={studyUploadInProcess}
                    register={register}
                    control={control}
                    isSecretary={isSecretary}
                    focus
                /> :
                <input
                  type="text"
                  className="form-control"
                  readOnly={true}
                  defaultValue={`${user.firstName} ${user.lastName} (${user.email})`}
                  value={`${user.firstName} ${user.lastName} (${user.email})`}
                />
            }
            
        </FormGroup>

        <FormGroup >

          <div className="d-flex" style={{gap: "15px"}}>
            <div style={{width: "100%"}}>
              <Label for="to">{t("patient")}</Label>

              {!isPatientDataNull || inviteOpen
              ? <input
                  type="text"
                  className="form-control"
                  readOnly={true}
                  defaultValue={
                    !isPatientDataNull ? `${patientData.firstName} ${patientData.lastName} (${patientData.email})` : t("patient")
                  }
                  value={
                    !isPatientDataNull ? `${patientData.firstName} ${patientData.lastName} (${patientData.email})` : t("patient")
                  }
                />
              : <UploadAsyncContacts
                  name="patient"
                  disabled={studyUploadInProcess}
                  register={register}
                  control={control}
                  isSecretary={isSecretary}
                  focus
                />
              }
            </div>
            
            {!inviteOpen ? 
            <div style={{marginTop: "15px"}}>
              
                <Button
                  disabled={studyUploadInProcess}
                  onClick={() => {
                    setInviteOpen(!inviteOpen);
                  }}
                >
                  {t("invite-user")}
                </Button>
            </div> : (<></>)
            }
          </div>
          
        </FormGroup>

        <Modal isOpen={inviteOpen} toggle={modalToggle} >
          <ModalHeader toggle={modalToggle}>{t('invite-user')}</ModalHeader>
          <ModalBody>
              <UploadInvitePatientForm setInviteOpen={setInviteOpen}/>
          </ModalBody>
        </Modal>

        <div className="d-flex justify-content-between">

            <div className={"upload-loading"}>
              {studyUploadInProcess ? 
                <>
                  <LoadingLocal/>
                  {tUpload("upload-loading")}
                </> : <></>
              }
            </div>
          
          <div style={mobile ? {width: "100%"} : {}}>
            <Button id="btn-save" size="sm" className="btn-info pull-right" disabled={studyUploadInProcess}>
              {t('btn-save')}
            </Button>

            <Button
              size="sm"
              disabled={studyUploadInProcess}
              id="btn-cancel"
              type="reset"
              className="btn-primary pull-right mr-3"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();
              }}
            >
              {t('btn-cancel')}
            </Button>
          </div>
        </div>
      </Form>
    </Fragment>
  );
};

export default UploadForm;
